import { render, staticRenderFns } from "./warning-svg.vue?vue&type=template&id=cf46716a&scoped=true&"
var script = {}
import style0 from "./warning-svg.vue?vue&type=style&index=0&id=cf46716a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf46716a",
  null
  
)

export default component.exports